import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import Menu from '@mui/material/Menu';
import { ThemeProvider } from '@mui/material/styles';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { selectIsTourneyRoom } from '../redux/selectorFns';
import { useAppSelector } from '../redux/store';
import { LIGHT_BLUE_COLOR, RIGHT_PANEL_BUTTON_HOVER_COLOR, RIGHT_PANEL_TOURNEY_ROOM_BUTTON_HOVER_COLOR } from '../styles/colors';
import { darkTheme } from '../styles/materialTheme';
import { HiddenPanelMenuItem } from './hiddenPanelMenuItem';
import { BASE_PANEL_BUTTON_CSS, BASE_PANEL_TOURNEY_ROOM_BUTTON_CSS } from './rightPanelButton';
export const MorePanelsButton = ({ panelTypes }) => {
    const isTourneyRoom = useAppSelector(selectIsTourneyRoom);
    const popupState = usePopupState({ variant: 'popover' });
    const buttonCss = useMemo(() => css(isTourneyRoom ? BASE_PANEL_TOURNEY_ROOM_BUTTON_CSS : BASE_PANEL_BUTTON_CSS, css `
          color: ${LIGHT_BLUE_COLOR};
        `, !isMobile &&
        css `
            &:hover {
              background-color: ${isTourneyRoom
            ? RIGHT_PANEL_TOURNEY_ROOM_BUTTON_HOVER_COLOR
            : RIGHT_PANEL_BUTTON_HOVER_COLOR};
            }
          `), [isTourneyRoom]);
    return (_jsxs(_Fragment, { children: [_jsx("button", { title: 'More Panels', css: buttonCss, ...bindTrigger(popupState), children: _jsx(MoreHorizRoundedIcon, {}) }), _jsx(ThemeProvider, { theme: darkTheme, children: _jsx(Menu, { ...bindMenu(popupState), children: panelTypes.map((panelType) => (_jsx(HiddenPanelMenuItem, { panelType: panelType, closeMenu: popupState.close }, panelType))) }) })] }));
};
